import styles from './ContactUs.module.scss';
import phonePng from '../assets/images/phone.png';
import emailPng from '../assets/images/email.png';
import addressPng from '../assets/images/address.png';
import qrCode1Png from '../assets/images/qrCode1.png';
import qrCode2Png from '../assets/images/qrCode2.png';
import qrCode3Png from '../assets/images/qrCode3.png';
import qrCode4Png from '../assets/images/qrCode4.png';
import { Button, Form, Input } from 'antd';
import { getLangName as t } from '../utils/index'

const { TextArea } = Input;

function ContactUs() {
    const [form] = Form.useForm();
    return <>
        <div className={styles.ContactUs}>
            <div className={styles.ContactUsOne}>
                <div className={styles.ContactUsOne_left}>
                    <h1 className={styles.ContactUsOne_left_title}>{t('GetQuote')}</h1>
                    <span className={styles.ContactUsOne_left_span}>{t('LeaveYourInfo')}</span>
                    <div className={styles.cUs_l_item}>
                        <img src={phonePng} alt="" />
                        <div className={styles.cUs_l_info}>
                            <div className={styles.cUs_l_info_title}>{t('SalesPhone')}：{t('PHONE111')}/{t('MrLiu')}</div>
                            <div className={styles.cUs_l_info_title}>{t('CustomerServicePhone')}：{t('PHONE222')}/{t('MsFan')}</div>
                        </div>
                    </div>
                   <div className={styles.cUs_l_item}>
                        <img src={emailPng} alt="" />
                        <div className={styles.cUs_l_info}>
                            <div className={styles.cUs_l_info_title}>{t('Email')}：steve@tkj-tech.com</div>
                            {/* <div className={styles.cUs_l_info_title}>{t('ReceptionPhone')}：0755-29177888</div>
                            <div className={styles.cUs_l_info_title}>{t('Fax')}：0755-29177766/29176877</div>
                            <div className={styles.cUs_l_info_title}>{t('PostalCode')}：518108</div> */}
                        </div> 
                    </div>
                    {/* <div className={styles.cUs_l_item}>
                        <img src={addressPng} alt="" />
                        <div className={styles.cUs_l_info}>
                            <div className={styles.cUs_l_info_title}>{t('ShenzhenHeadquarters')}：深圳市宝安区石岩湖松白路北大方正科技园A1栋</div>
                            <div className={styles.cUs_l_info_title}>{t('DongguanIntelligentManufacturingBase')}：东莞市清溪镇大利村清渔路107号D栋</div>
                        </div>
                    </div> */}
                </div>
                <div className={styles.ContactUsOne_right}>
                    {/* <div className={styles.ContactUsOne_right_box}>
                        <Form
                            layout={'vertical'}
                            form={form}
                            initialValues={{ layout: 'vertical' }}
                        >
                            <Form.Item label={t('YourName')}>
                                <Input size="large" placeholder={t('EnterYourName')} />
                            </Form.Item>
                            <Form.Item label={t('YourPhone')}>
                                <Input size="large" placeholder={t('EnterYourPhone')} />
                            </Form.Item>
                            <Form.Item label={t('YourRequirements')}>
                                <TextArea placeholder={t('EnterYourRequirements')} autoSize={
                                    { minRows: 8 }
                                } />
                            </Form.Item>
                            <Form.Item>
                                <Button type="primary" size="large">{t('Submit')}</Button>
                            </Form.Item>
                        </Form>
                    </div> */}
                </div>
            </div>
            <div className={styles.ContactUsTwo}>
                <div className={styles.ContactUsTwo_left}>
                    <div>
                        <h1>深圳市泰科佳科技有限公司</h1>
                        {/* <span>{t('Address')}：深圳市宝安区石岩湖松白路北大方正科技园A1栋</span> */}
                    </div>
                </div>
                <div className={styles.ContactUsTwo_right}>
                    <div>
                        <span>WhatsApp</span>
                        <img src={qrCode1Png} />
                    </div>
                    <div>
                        <span>Wechat</span>
                        <img src={qrCode2Png} />
                    </div>
                    <div>
                        <span>YouTube</span>
                        <img src={qrCode4Png} />
                    </div>
                    <div>
                        <span>TikTok</span>
                        <img src={qrCode3Png} />
                    </div>
                </div>
            </div>
        </div>
    </>;
}

export default ContactUs;